class ExpressAddressPanelController {
    constructor($sce, $window, $state, moveFocus, settings, loginService, shopperService, fulfilmentService, expressService) {
        this.$sce = $sce;
        this.$window = $window;
        this.$state = $state;
        this.moveFocus = moveFocus;
        this.settings = settings;
        this.loginService = loginService;
        this.shopperService = shopperService;
        this.fulfilmentService = fulfilmentService;
        this.expressService = expressService;
    }

    $onInit() {
        this.isRequiredFieldsEntered = false;
        this.isValidForExpress = false;
        this.isAddressValidated = false;
        this.isDeliveryWindowClosed = false;
        this.isEtaEnabled = this.settings.expressLandingPage.expressETAEnabled;
        this.isEtaValid = false;
        this.expressAddressPanelHeaderMessage = this.$sce.trustAsHtml(this.settings.expressLandingPage.expressValueProposition);
        this.errorMessage = null;
    }

    get isAddressValidForExpressOrNotValidated() {
        return (this.isAddressValidated && this.isValidForExpress && this.isRequiredFieldsEntered && !this.isDeliveryWindowClosed) || !this.isAddressValidated;
    }

    get isExpressAvailableNow() {
        return this.isValidForExpress && !this.isDeliveryWindowClosed;
    }

    get isExpressUnavailable() {
        return this.isAddressValidated && !this.isValidForExpress;
    }

    get shouldShowEtaValueProposition() {
        return this.isAddressValidForExpressOrNotValidated && !this.isEtaValid && this.isEtaEnabled;
    }

    get shouldShowExpressValueProposition() {
        return this.isAddressValidForExpressOrNotValidated && !this.isEtaValid && !this.isEtaEnabled;
    }

    get isExpressWindowClosedNow() {
        return this.isAddressValidated && this.isDeliveryWindowClosed;
    }

    get isOnManualAddressValidation() {
        return (this.addressEntryMode === 'MANUAL') && (!this.isValidForExpress || this.isDeliveryWindowClosed);
    }

    get isAutoAddressValidated() {
        return !this.isValidForExpress || (this.isValidForExpress && this.isDeliveryWindowClosed);
    }

    get isIneligibleForExpressOrWindowClosed() {
        return this.isAddressValidated && (!this.isValidForExpress || this.isDeliveryWindowClosed);
    }

    manualAddressMode() {
        if (this.isOnManualAddressValidation) {
            return 'SEARCH';
        }
        if (this.isExpressAvailableNow) {
            return 'SHOP';
        }
        return '';
    }

    onSaveAutoAddress(address) {
        this.isAddressValidated = false;
        this.expressService.getExpressStoreInfo(address.Id, null, null)
            .then((response) => {
                this.isValidForExpress = response.IsExpress;
                this.isAddressValidated = true;
                this.isRequiredFieldsEntered = true;
                this.isDeliveryWindowClosed = response.IsDeliveryWindowClosed;
                this.etaDisplayString = response.EtaDisplayString;
                this.isEtaValid = this.etaDisplayString !== '';
                this.errorMessage = response.ErrorMessage;
                this.mapFulfilmentStoreDetails(response);
                if (this.onAddressLookUp) {
                    this.onAddressLookUp({ response });
                }
            });
    }

    onManualAddressChange(address) {
        this.isAddressValidated = false;
        if (address.street1 && this.isValidSuburbValue(address.suburb) && address.postcode) {
            this.isRequiredFieldsEntered = true;
            this.street1 = address.street1;
            this.street2 = address.street2;
            this.suburb = address.suburb;
            this.postcode = address.postcode;
            this.moveFocus('#validateAddressManually');
        } else {
            this.isRequiredFieldsEntered = false;
        }

        if (this.onAddressLookUp) {
            this.onAddressLookUp(null);
        }
        this.isEtaValid = false;
        this.isValidForExpress = false;
        this.isDeliveryWindowClosed = null;
    }

    manualDeliveryAddressChanged() {
        if (this.postcode && this.suburb) {
            this.isAddressValidated = false;
            this.expressService.getExpressStoreInfo(null, this.suburb, this.postcode)
                .then((response) => {
                    this.mapFulfilmentStoreDetails(response);
                });
        } else {
            this.isValidForExpress = false;
            this.isDeliveryWindowClosed = null;
        }
    }

    mapFulfilmentStoreDetails(response) {
        if (response.IsExpress) {
            this.deliveryWindowId = response.DeliveryWindowId;
            this.addressId = response.AddressId;

            if (this.addressEntryMode === 'MANUAL') {
                this.moveFocus('#manualModeshopExpress');
            } else {
                this.moveFocus('#autoModeshopExpress');
            }
        } else {
            this.moveFocus('#continueShoping');
        }

        this.etaDisplayString = response.EtaDisplayString;
        this.isEtaValid = this.etaDisplayString !== '';
        this.isValidForExpress = response.IsExpress;
        this.isAddressValidated = true;
        this.isDeliveryWindowClosed = response.IsDeliveryWindowClosed;

        this.errorMessage = response.ErrorMessage;
        if (this.onAddressLookUp) {
            this.onAddressLookUp({ response });
        }
    }

    setAutoAddressValidationInfo() {
        if (this.shopperService.IsGuest) {
            this.loginService.promptForLogin(this.loginService.LoginToContinueMessage, undefined, undefined, undefined, undefined, undefined, () => {
                this.validateExpressAddress(this.shopperService.shopper.Id, this.addressId);
            });
        } else {
            this.validateExpressAddress(this.shopperService.shopper.Id, this.addressId);
        }
    }

    setManualAddressValidationInfo() {
        if (this.shopperService.IsGuest) {
            this.loginService.promptForLogin(this.loginService.LoginToContinueMessage, undefined, undefined, undefined, undefined, undefined, () => {
                this.validateManualAddress(this.shopperService.shopper.Id, this.street1, this.street2, this.suburb, this.postcode);
            });
        } else {
            this.validateManualAddress(this.shopperService.shopper.Id, this.street1, this.street2, this.suburb, this.postcode);
        }
    }

    isOnManualSearchMode() {
        return (this.addressEntryMode === 'MANUAL' && !this.isAddressValidated);
    }

    onSetEntryMode(mode) {
        this.addressEntryMode = mode;
        this.isRequiredFieldsEntered = false;
        this.isEtaValid = false;
        this.isValidForExpress = false;
        this.isAddressValidated = false;

        if (this.onAddressLookUp) {
            this.onAddressLookUp(null);
        }
    }

    refreshPage() {
        if (this.isExpressAvailableNow) {
            this.expressService.setShowExpressDialogInStorage();
        }

        this.$window.location.href = '/';
    }

    validateExpressAddress(shopperId, addressId) {
        this.expressService.getExpressDeliveryAddress(shopperId, addressId)
            .then((response) => {
                this.saveFulfilment(response.AddressId).then(() => { this.refreshPage(); });
            });
    }

    validateManualAddress(shopperId, street1, street2, suburb, postcode) {
        this.expressService.getExpressManualAddress(shopperId, street1, street2, suburb, postcode)
            .then((response) => {
                this.saveFulfilment(response.AddressId).then(() => { this.refreshPage(); });
            });
    }

    saveFulfilment(addressId) {
        const currentDate = new Date();
        const truncatedCurrentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
        return this.fulfilmentService.saveFulfilment({
            fulfilmentMethod: 'Courier',
            address: { AddressId: addressId },
            fulfilmentWindow: { time: { Id: this.deliveryWindowId }, date: { Date: truncatedCurrentDate } },
        });
    }

    isValidSuburbValue(suburb) {
        return (suburb && !suburb.startsWith('(0) Suburbs found for')) || false;
    }
}

ExpressAddressPanelController.$inject = ['$sce', '$window', '$state', 'MoveFocus', 'Settings', 'LoginService', 'ShopperService', 'FulfilmentService', 'ExpressService'];

const expressAddressPanelControllerComponentDefinition = {
    bindings: {
        onAddressLookUp: '&?',
    },
    controller: ExpressAddressPanelController,
    template: require('./express-address-panel.component.html').trim(),
};

module.exports = {
    ExpressAddressPanelController,
    expressAddressPanelControllerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/express/express-address-panel.component.js